import hotGuests from './hot-guests.vue'

export default hotGuests
